import "core-js/modules/es.array.push.js";
export default {
  name: "Paging",
  data: function data() {
    return {
      maxNumberDisplayed: 6,
      minPageToOverflow: 4,
      numberOfSideDisplay: 2
    };
  },
  props: ["numberOfPages", "currentPage"],
  computed: {
    directPage: {
      get: function get() {
        return this.currentPage;
      },
      set: function set(newValue) {}
    },
    directPages: function directPages() {
      var temp = [];
      if (this.numberOfPages > 1) {
        for (var i = 1; i <= this.numberOfPages; i++) {
          temp.push(i);
        }
      }
      return temp;
    }
  },
  methods: {
    changePage: function changePage(page) {
      if (page != this.currentPage) this.$emit("changePage", page - 1);
    }
  }
};